import React, { useState, useRef } from 'react';
import ReactPlayer from 'react-player';

const VideoPlayer = (url) => {
    // eslint-disable-next-line no-unused-vars
    const [, setProgress] = useState(0);
    const playerRef = useRef(null);

    const onComplete = () => {
        console.log("Video completed");
        // Additional logic on video completion can be added here
    }


    const handleProgress = ({ played }) => {
        setProgress(played);
        if (played >= 0.95) onComplete();
    };

    return (
        <div className="video-container">
            <ReactPlayer
                ref={playerRef}
                url={url}
                width="100%"
                height="auto"
                controls
                onProgress={handleProgress}
            />
        </div>
    );
};

export default VideoPlayer;